module.exports = __webpack_public_path__ + "img/img_tishi.7cf3a671.png";